












































import { Component, Prop, Vue } from 'nuxt-property-decorator';

import { PerformanceEvent, usePerformanceUpcomingEvents } from '@/composables/performance-events';
import { capitalizeFirst } from '@/composables/utils';
import { formatSv } from '@/composables/datefns';

import { IconArrowRight } from '@/icons';

@Component({
  components: {
    IconArrowRight,
  },
  setup (props: any) {
    return usePerformanceUpcomingEvents(props.performanceId, 6);
  },
})
export default class ShowsOMBookButton extends Vue {
  @Prop({ type: String, required: true }) performanceId!: string;

  performanceUpcomingEvents!: PerformanceEvent[];
  performanceUpcomingEventsLoading!: boolean;

  modalOpen = false;

  get shows () {
    return this.performanceUpcomingEvents.map((event) => {
      const startDate = new Date(event.startDate);
      // const endDate = new Date(event.endDate);

      return {
        title: capitalizeFirst(formatSv(startDate, 'EEEE d MMMM')),
        subtitle: `Kl. ${formatSv(startDate, 'HH:mm')} i ${event.locationStage}`,
        cancelled: false,
        soldOut: false,
        bookingLink: event.purchaseUrl,
      };
    });
  }

  openModal (open: boolean) {
    this.modalOpen = open;
  }
}

